export default __webpack_public_path__ + "static/media/logo-masamune-small-black.822f5481.svg";